<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
  <app-header [page]="'Admin'"></app-header>
  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="fw-bold mb-0">
          {{ isEditMode ? 'Edit Policy' : 'New Policy' }}
        </h4>
        <div class="text-muted small">
          Configure the policy that drives fields, documents and user verification flow
        </div>
      </div>

      <button class="btn btn-outline-secondary btn-sm" (click)="cancel()">
        Back
      </button>
    </div>

    <div *ngIf="loading" class="text-center py-4">
      <div class="spinner-border"></div>
    </div>

    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="save()" class="card shadow-sm border-0">
      <div class="card-body">

        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Jurisdiction</label>
            <select class="form-select" formControlName="jurisdictionId">
              <option value="">Select jurisdiction</option>
              <option *ngFor="let item of jurisdictions" [value]="item.id">
                {{ item.code }} - {{ item.name }}
              </option>
            </select>

            <div class="small text-danger mt-1" *ngIf="jurisdictionId?.touched && jurisdictionId?.invalid">
              Jurisdiction is required.
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label">Tier Code</label>
            <select class="form-select" formControlName="tierId" (change)="onTierChanged($any($event.target).value)">
              <option value="">Select tier</option>
              <option *ngFor="let item of availableTiers" [value]="item.id">
                {{ item.tierCode }} - {{ item.customerType }}
              </option>
            </select>

            <div class="small text-danger mt-1" *ngIf="tierId?.touched && tierId?.invalid">
              Tier code is required.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Customer Type</label>
            <select class="form-select" formControlName="customerType">
              <option *ngFor="let item of customerTypes" [ngValue]="item.value">{{ item.label }}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label">Product Type</label>
            <select class="form-select" formControlName="productType">
              <option *ngFor="let item of productTypes" [ngValue]="item.value">{{ item.label }}</option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label">Version</label>
            <input class="form-control" type="number" min="1" formControlName="version" placeholder="1" />

            <div class="small text-danger mt-1" *ngIf="version?.touched && version?.invalid">
              Version must be at least 1.
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Name</label>
            <input class="form-control" formControlName="name" placeholder="KYC Policy Name" />

            <div class="small text-danger mt-1" *ngIf="name?.touched && name?.invalid">
              Policy name is required.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Status</label>
            <select class="form-select" formControlName="status">
              <option *ngFor="let item of policyStatuses" [ngValue]="item.value">{{ item.label }}</option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label">Effective From</label>
            <input class="form-control" type="date" formControlName="effectiveFrom" />

            <div class="small text-danger mt-1" *ngIf="effectiveFrom?.touched && effectiveFrom?.invalid">
              Effective from date is required.
            </div>
          </div>

          <div class="col-md-4">
            <label class="form-label">Effective To</label>
            <input class="form-control" type="date" formControlName="effectiveTo" />
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Manual Review</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresManualReview" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Sanctions Screening</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresSanctionsScreening" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Source Of Funds</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresSourceOfFunds" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label d-block">Proof Of Address</label>
            <div class="form-check form-switch mt-2">
              <input class="form-check-input" type="checkbox" formControlName="requiresProofOfAddress" />
              <label class="form-check-label">Yes</label>
            </div>
          </div>
        </div>

        <div class="mt-4 d-flex gap-2 flex-wrap">
          <button class="btn btn-primary" type="submit" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update Policy' : 'Create Policy' }}
          </button>

          <button class="btn btn-outline-secondary" type="button" (click)="cancel()">
            Cancel
          </button>

          <button *ngIf="isEditMode" class="btn btn-outline-primary" type="button" (click)="openFields()">
            Manage Fields
          </button>

          <button *ngIf="isEditMode" class="btn btn-outline-primary" type="button" (click)="openDocuments()">
            Manage Documents
          </button>

          <button *ngIf="isEditMode" class="btn btn-outline-primary" type="button" (click)="openRules()">
            Manage Rules
          </button>
        </div>

      </div>
    </form>

    <app-footer></app-footer>
  </main>
</div>